import { FaderRow } from "./FaderRow";

interface Props {
  audioEnabled: boolean;
  onPlaySweep: () => void;
  sweepLoop: boolean;
  onToggleSweepLoop: () => void;
  /** Sweep tempo: 1 = default, 0.5–2 = half to double; applied live mid-sweep. */
  sweepRate: number;
  onSweepRateChange: (rate: number) => void;
}

export function SweepSection(props: Props) {
  const { audioEnabled, onPlaySweep, sweepLoop, onToggleSweepLoop, sweepRate, onSweepRateChange } = props;
  return (
    <div style={{ marginTop: 6 }}>
      <div style={{ display: "flex", gap: 4 }}>
        <button onClick={onPlaySweep} disabled={!audioEnabled}>
          Play feature sweep
        </button>
        <button
          className={sweepLoop ? "active" : ""}
          onClick={onToggleSweepLoop}
          disabled={!audioEnabled}
          title="Repeat the sweep continuously; epoch changes sweep the new epoch"
        >
          {sweepLoop ? "Loop: on" : "Loop: off"}
        </button>
      </div>
      {/* Log-scaled track so 100% sits dead-centre between 50% and 200%. */}
      <FaderRow
        label="Sweep speed"
        min={-1}
        max={1}
        value={Math.log2(sweepRate)}
        onChange={(v) => onSweepRateChange(2 ** v)}
        readout={`${(sweepRate * 100).toFixed(0)}%`}
        style={{ marginTop: 6 }}
      />
      <p className="muted" style={{ fontSize: 11, marginTop: 4 }}>
        One pluck per detected peak, red→blue. Plays automatically when the
        epoch changes{sweepLoop ? "; looping until switched off" : ""}.
        Speed changes apply mid-sweep without restarting it.
      </p>
    </div>
  );
}
